export const OOPS = "oops";
export const CLOSE = "close";

export const enum HeaderComponent {
  MinimalHeader = "MinimalHeader",
  FullHeader = "FullHeader"
}

export const enum BodyComponent {
  MobileFull = "MobileFull",
  MobileMin = "MobileMin",
  DesktopFull = "DesktopFull",
  DesktopMin = "DesktopMin"
}

export const enum DeviceTypes {
  Mobile = "Mobile",
  Desktop = "Desktop"
}

export const enum DataLayout {
  Full = "Full",
  Min = "Min"
}
